<template>
  <button class="inline-help-button !bg-transparent" @click.prevent="toggle">
    <i class="fa fas fa-question-circle"></i>
  </button>
  <Popover ref="op">
    <div class="inline-help-panel"
          data-controller="autoposition"
          data-autoposition-offset-value="-1.5rem"
          :data-autoposition-force-right-value="forceRight">
      <slot></slot>
    </div>
  </Popover>
</template>

<script setup>
  import { ref } from "vue"
  import Popover from 'primevue/popover'

  const op = ref()
  const props = defineProps({
    forceRight: { type: Boolean, default: false },
    content: { type: String, default: '' }
  })

  const toggle = (event) => {
    op.value.toggle(event)
  }
</script>
